export interface TypeformProps {
  app_name: string
  device_model?: string
  email?: string
  event_title: string
  node_id?: number
  os?: string
  os_version?: string
  stream_title: string
  stream_id: any
  user_id?: string
  vertical?: string
  event_id?: number
}

/**
 * The base link to the survey created within the FloSports Typeform account.
 *
 * [TypeForm Stream Feedback Survey]{@link https://admin.typeform.com/form/FzLanulr/share#/}
 */
const TYPEFORM_STREAM_FEEDBACK_URL = 'https://form.typeform.com/to/FzLanulr?typeform-medium=embed-snippet#'

const transformTypeformPropsToQueryParamString = (props: TypeformProps): string => {
  return Object.entries(props).reduce((acc, curr) => {
    return acc + `${curr[0]}=${curr[1]}&`
  }, '')
}

export const buildTypeformStreamFeedbackUrlFromProps = (props: TypeformProps): string => {
  const params = transformTypeformPropsToQueryParamString(props)
  return encodeURI(`${TYPEFORM_STREAM_FEEDBACK_URL}${params}`)
}
